import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { ExportDetailsDataApiModel } from "@gemeco/Services/GemecoInventoryDataService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

interface GetExportsDetailsDataState {
    isLoading: boolean;
    mainData: ExportDetailsDataApiModel | [];
}

const initialState: GetExportsDetailsDataState = {
    isLoading: false,
    mainData: [],
};

const reducer = createTypedReducerWithImmer(initialState, {
    "Custom/ExportDetailsData/BeginLoadExportDetailsData": (draft: Draft<GetExportsDetailsDataState>) => {
        draft.isLoading = true;
    },
    "Custom/ExportDetailsData/CompletedLoadExportDetailsData": (
        draft: Draft<GetExportsDetailsDataState>,
        action: { result: ExportDetailsDataApiModel },
    ) => {
        draft.isLoading = false;
        draft.mainData = action.result;
    },
});

(reducers as any).GemecoExportDetailsReducer = reducer;

export type GemecoExportDetailsState = {
    GemecoExportDetailsReducer: GetExportsDetailsDataState;
} & ApplicationState;

type Reducers = {
    GemecoExportDetailsReducer: typeof reducer;
};

export type GemecoExportDetailsActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
